<template>
  <div>
    <div class="headControll">
      <div class="head">
        <div class="headT" @click="goHome()">工程造价咨询业信息管理</div>
        <div class="perControll">
          <img src="@/assets/img/per.png" alt="" />

          <!--          v-if="userinfo && userinfo.length"-->
          <div v-if="userinfo" class="nicknameShow">
            <el-dropdown>
              <span class="el-dropdown-link">
                {{ userinfo.company_info.name
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click="editZl()">
                  <span @click="editZl()">修改资料</span>
                </el-dropdown-item>
                <el-dropdown-item @click="logout()">
                  <span @click="logout()">退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

                    <div
                      v-else
                      class="nicknameShow"
                      @click="
                        $router.push({
                          name: 'login',
                        })
                      "
                    >
<!--          <div-->
<!--            v-else-->
<!--            class="nicknameShow"-->
<!--            @click="msg"-->
<!--          >-->
            请先登录
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Head",
  computed: {
    ...mapState(["userinfo"])
  },
  mounted() {
    // console.log(this.userinfo, "-------------tt");
  },
  methods: {
    //消息提示
    msg() {
      this.$message({
        message: "系统更新中",
        type: "error"
      });
    },
    logout() {
      // console.log("退出");
      // 清空token
      // localStorage.removeItem("vuex");
      // 清空store
      this.$store.dispatch("logout");
      // 跳转到登录页
      this.$router.push({ name: "login" });
    },
    editZl() {
      this.$router.push({ name: "setAccount" });
    },
    //点击logo去已登录的入口页
    goHome() {
      this.$router.push({ name: "index" });
    }
  }
};
</script>

<style lang="less" scoped>
.headControll {
  width: 100%;
  height: 40px;
  background: #000000;
  align-items: center;
  display: flex;

  .head {
    width: 1200px;
    margin: auto;
    display: flex;
    justify-content: space-between;

    .headT {
      width: 224px;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 14px;
      cursor: pointer;
    }

    .perControll {
      display: flex;
      align-items: center;
      cursor: pointer;

      .nicknameShow {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }

      img {
        width: 14px;
        height: 14px;
      }

      div {
        height: 17px;
        font-size: 12px;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        margin-left: 4px;
      }
    }
  }
}
</style>
